var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIconDate = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  fill: "none",
  viewBox: "0 0 16 16"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 13.429,
  height: 11.281,
  x: 1.861,
  y: 2.852,
  stroke: "currentColor",
  strokeWidth: 0.894,
  rx: 0.627
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeWidth: 0.894,
  d: "M1.861 3.48c0-.347.28-.628.627-.628h12.175c.346 0 .627.28.627.627v1.702H1.861V3.479Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeWidth: 0.782,
  d: "M12.16 1.42v1.97M5 1.42v1.97"
})));
export default SvgIconDate;